/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Shipment } from './shipment';


export interface Build { 
    antenna?: Build.AntennaEnum;
    configConfirmed?: string;
    customerContact?: string;
    customerRefNo?: string;
    failureReason?: string;
    housingLabel?: string;
    housingTypeId?: string;
    manufacturingCompleted?: string;
    orderItemConfigurationId?: string;
    packedAt?: string;
    readyForTest?: string;
    shipment?: Shipment;
    testStart?: string;
    uhfCommunication?: boolean;
    weight?: number;
}
export namespace Build {
    export const AntennaEnum = {
        Vhf: 'VHF',
        Uhf: 'UHF',
        VhfAndUhf: 'VHF_AND_UHF'
    } as const;
    export type AntennaEnum = typeof AntennaEnum[keyof typeof AntennaEnum];
}


export type AntennaEnum = typeof Build.AntennaEnum[keyof typeof Build.AntennaEnum];
